import { ReportBlockTypeEnum } from './report-block-type.enum';

export enum SortableMentionBlockTypeEnum {
    TOP_MENTIONS = ReportBlockTypeEnum.TOP_MENTIONS,
    TOP_POSTS = ReportBlockTypeEnum.TOP_POSTS
}
